import React from 'react';
import success from '../images/success.png';

const ChangePasswordSuccess = () => (
  <div className="password-success">
    <img
      src={success}
      alt="Success"
    />
    <h3>Your password has been successfully changed.</h3>
  </div>
);

export default ChangePasswordSuccess;
